export enum UserDetailPageModeEnum {
  // 参照モード
  REFERENCE = 'UserDetailReference',
  // 編集モード
  EDITION = 'UserDetailEdition',
  // 新規モード
  ADDTION = 'UserDetailAddition',
  // 参照モード(ゲスト)
  REFERENCE_GUEST = 'UserDetailReferenceGuest',
  // 編集モード(ゲスト)
  EDITION_GUEST = 'UserDetailEditionGuest',
}
